import { usePublicEventContext } from '@event/contexts/PublicEventContext';
import { useGetLanguageSpokenOptionsQuery } from '@event/services/events';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { Avatar, CircularProgress, Typography } from '@mui/material';
import clsx from 'clsx';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

const LanguageSpoken = (props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => {
    const {
        event: { data: event },
    } = usePublicEventContext();

    const { data: languages, isLoading: areLanguageOptionsLoading } = useGetLanguageSpokenOptionsQuery();
    const language = useMemo(
        () => languages?.find((lang) => lang.code === event?.language_spoken),
        [languages, event?.language_spoken]
    );

    return (
        <>
            {event?.language_spoken ? (
                <div {...props} className={clsx('mb-2 flex justify-between', props.className)}>
                    <div className="flex items-center gap-2">
                        <ChatBubbleOutlineIcon fontSize="small" />
                        <Typography fontSize={14} fontWeight={700} color="neutral-900.main">
                            <FormattedMessage id="common.language.uppercase" defaultMessage="LANGUAGE" />
                        </Typography>
                    </div>
                    <div className="flex items-center gap-1">
                        <Avatar
                            src={`/static/flags/${
                                event?.language_spoken.toString().toLowerCase() === 'en'
                                    ? 'us_uk'
                                    : event?.language_spoken.toString().toLowerCase()
                            }.svg`}
                            className="w-[17px] h-[17px]"
                        />
                        <Typography fontSize={16} color="neutral-900.main">
                            {areLanguageOptionsLoading ? (
                                <CircularProgress className="size-6" />
                            ) : (
                                language?.name ?? null
                            )}
                        </Typography>
                    </div>
                </div>
            ) : null}
        </>
    );
};

export { LanguageSpoken };
